import { Modal } from "./Modal";
import { SaveAddressForm } from "../Form/Forms/Address/SaveAddressForm";

export function SaveAddressModal({ open, setOpen }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <SaveAddressForm open={open} setOpen={setOpen} />
    </Modal>
  );
}
